// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationMeta } from './PaginationMeta';
import {
    PaginationMetaFromJSON,
    PaginationMetaFromJSONTyped,
    PaginationMetaToJSON,
    PaginationMetaToJSONTyped,
} from './PaginationMeta';

/**
 * 
 * @export
 * @interface IncidentHistoryResponseMeta
 */
export interface IncidentHistoryResponseMeta {
    /**
     * 
     */
    items?: PaginationMeta;
}

/**
 * Check if a given object implements the IncidentHistoryResponseMeta interface.
 */
export function instanceOfIncidentHistoryResponseMeta(value: object): value is IncidentHistoryResponseMeta {
    return true;
}

export function IncidentHistoryResponseMetaFromJSON(json: any): IncidentHistoryResponseMeta {
    return IncidentHistoryResponseMetaFromJSONTyped(json, false);
}

export function IncidentHistoryResponseMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentHistoryResponseMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : PaginationMetaFromJSON(json['items']),
    };
}

export function IncidentHistoryResponseMetaToJSON(json: any): IncidentHistoryResponseMeta {
    return IncidentHistoryResponseMetaToJSONTyped(json, false);
}

export function IncidentHistoryResponseMetaToJSONTyped(value?: IncidentHistoryResponseMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': PaginationMetaToJSON(value['items']),
    };
}

